import React from 'react';
import styles from './NoData.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
const NoData = ({
  text = 'No Data Found',
  type = 'noData',
  containerStyle,
}) => {
  return (
    <div className={`${styles['cont']} `} style={containerStyle}>
      <SvgWithBranding type={type} />
      <p>{text}</p>
    </div>
  );
};

export default NoData;
